import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function GestaoPlanoPage() {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/gestao-plano/plano', { replace: true });
  }, [navigate]);

  return null;
}
